<template>
    <div class="list">
        <div class="flex__around search-box">
            <div class="flex align-center search__item">
                <span class="fs_28 c_b3 jcicon jcicon-sousuo1">&nbsp;</span>
                <input class="fs_28" type="text" placeholder="请输入关键字搜索" v-model="loads.keyword">
            </div>
        </div>
        <div class="flex__between__center nav">
            <div class="flex__between__center nav__left">
                <div class="flex__between__center">
                    <div @click="picker_show=true">
                        <span class="fs_30" :class="loads.order_id!=4?'c_main':'c_4d'">{{sort_list[sort_index].name}}</span>
                        <span class="fs_30 jcicon jcicon-xiala2" :class="loads.order_id!=4?'c_main':'c_4d'"></span>
                    </div>
                    <span class="fs_30" :class="loads.order_id==4?'c_main':'c_4d'" @click="loads.order_id=4">销量优先</span>
                </div>
                <span class="fs_40 c_80 jcicon" :class="style?'jcicon-leimupinleifenleileibie':'jcicon-copy'" @click="style=!style"></span>
            </div>
            <div class="flex__center__center screen-box" @click="sidebar=!sidebar">
                <span class="fs_30 c_4d">筛选</span>
                <span class="fs_30 c_80 jcicon jcicon-shaixuan"></span>
            </div>
        </div>
        <!-- 一行俩 -->
        <div class="column-box flex__between wrap" v-show="style">
            <div class="column__item" v-for="(item,index) in list" :key="item.id" v-link="'/Mall/Detail/'+item.id">
                <img :src="item.cover_img" alt="">
                <div class="flex__null__between column__info">
                    <span class="fs_28 c_1a lh_40 ellipsis_two">{{item.name}}</span>
                    <div class="mt_10 lh_40">
                        <span class="fs_26 c_main">¥</span>
                        <span class="fs_30 c_main">{{item.price}}</span>
                        <span class="fs_24 c_80">&ensp;已售{{item.sales}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 一行一个 -->
        <div class="row-box" v-show="!style&&list.length">
            <div class="flex row__item" v-for="(item,index) in list" :key="index" v-link="'/Mall/Detail/'+item.id">
                <img :src="item.cover_img" alt="">
                <div class="flex__null__around row__info">
                    <span class="fs_30 c_1a lh_40 ellipsis_two">{{item.name}}</span>
                    <div class="mt_10 lh_40">
                        <span class="fs_26 c_main">¥</span>
                        <span class="fs_36 c_main">{{item.price}}</span>
                    </div>
                    <span class="fs_24 c_80">&ensp;已售{{item.sales}}</span>
                </div>
            </div>
        </div>
        <!-- 侧边栏 -->
        <div class="sidebar-box" v-show="sidebar">
            <div class="layer" @click="sidebar=!sidebar"></div>
            <div class="content">
                <p class="fs_40 c_1a fw_500">选择分类</p>
                <div class="sidebar__item bb_1" v-for="(item,index) in category" :key="index">
                    <div class="flex__between" @click="item.click_number=!item.click_number">
                        <span class="fs_28 c_66">{{item.name}}</span>
                        <span class="jcicon fs_34 c_98" :class="!item.click_number?'jcicon-icon-shang':'jcicon-huaban'"></span>
                    </div>
                    <div class="flex wrap category__list" v-show="!item.click_number">
                        <div class="flex__around__center category__item ellipsis_one" :class="item1.is_chose?'active':''" v-for="(item1,index1) in item.lower_category" :key="index1" @click="item1.is_chose=!item1.is_chose">
                            <span class="fs_24" :class="item1.is_chose?'c_main':'c_4d'">{{item1.name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex__end__center footer">
                <div class="flex"> 
                    <button class="reset" @click="reset">重置</button>
                    <button class="sure" @click="sure">确定</button>
                </div>
            </div>
        </div>
        <jc-list v-if="refresh" :url="'/Mall/getListList'" :loads="loads" @load='getList'></jc-list>
        <!-- 排序方式picker -->
        <van-popup v-model="picker_show" position="bottom" :overlay="true">
            <van-picker 
                class="van-picker" 
                show-toolbar
                :columns="sort_list" 
                value-key="name"
                @cancel="picker_show=false"
                @confirm="setSort" />
        </van-popup>
    </div>
</template>
<script>
export default {
    name:'List',
    data(){
        return{
            picker_show: false, //排序方式
            sort_index: 0,
            refresh: false, //刷新组件用
            style: true, //展示类型 ture：1行2;false:1行1
            sidebar: false,
            list:[],
            loads:{
                user_id: localStorage.user_id,
                order_id: 1,
                second_category_id: '',
                keyword: '',
                page:1
            },
            category:[
                {
                    lower_category:[{}]
                }
            ],
            sort_list:[
                {
                    id:1,
                    name:'综合排序'
                },
                {
                    id:2,
                    name:'价格降序'
                },
                {
                    id:3,
                    name:'价格升序'
                }
            ]
        }
    },
    methods:{
        getList (data) { 
            this.list=data;
        },
        // 排序方式
        setSort(value,index){
            this.picker_show=false;
            this.sort_index=index;
            this.loads.order_id=this.sort_list[index].id;
        },
        // 确定分类
        sure(){
            this.sidebar=false;
            this.loads.second_category_id='';
            let array=[];
            for(let i=0;i<this.category.length;i++){
                for(let j=0;j<this.category[i].lower_category.length;j++){
                    if(this.category[i].lower_category[j].is_chose){
                     array.push(this.category[i].lower_category[j].second_category_id);
                    }   
                }
            }
            this.loads.second_category_id=array.join(',');
        },
        // 重置分类
        reset(){
            this.loads.second_category_id='';
            for(let i=0;i<this.category.length;i++){
                for(let j=0;j<this.category[i].lower_category.length;j++){
                    if(this.category[i].lower_category[j].is_chose){
                        this.category[i].lower_category[j].is_chose=0;
                    }   
                }
            }
        }
    },
    mounted(){
        if(this.$store.state.keyword){
            this.loads.keyword=this.$store.state.keyword;
        }
        this.axios.post('/wechat.php/Mall/getListData',{
            first_category_id:this.$route.params.first_category_id,
            second_category_id: this.$route.params.second_category_id
        }).then(
            res=>{
                this.category=res.data.data.category;
                let category_arr=[];
                for(let i=0;i<this.category.length;i++){
                    for(let j=0;j<this.category[i].lower_category.length;j++){
                        if(this.category[i].lower_category[j].is_chose==1){
                            category_arr.push(this.category[i].lower_category[j].second_category_id);
                        }
                    }
                }
                this.loads.second_category_id=category_arr.join();
                this.refresh=true;
            }
        )
    },
    destroyed(){
        this.$store.commit('setKeyword','');
    }
}
</script>
<style scoped>
    .nav{
        height: 90px;
        background: #fff;
    }
    .nav__left{
        width: 600px;
        padding: 0 30px;
    }
    .nav__left>div{
        width: 340px;
        height: 90px;
    }
    .screen-box{
        width: 150px;
        height: 40px;
        border-left: 1px solid #e6e6e6;
    }
    /* 商品 */
    .column-box{
        padding: 0 24px;
    }
    .column__item{
        width: 340px;
        margin-top: 20px;
        background: #fff;
        border-radius: 10px;
    }
    .column__item img{
        width: 340px;
        height: 340px;
        border-radius: 10px 10px 0 0;
    }
    .column__info{
        height: 165px;
        padding: 20px 10px;
    }
    /* 一行一个 */
    .row-box{
        overflow: hidden;
        padding: 0 30px 30px;
        background: #fff;
    }
    .row__item{
        margin-top: 30px;
    }
    .row__item img{
        width: 280px;
        height: 280px;
        border-radius: 10px;
    }
    .row__info{
        margin-left: 30px;
    }
    /* 浮层 */
    .sidebar-box{
        position: fixed;
        top: 0;
        bottom: 0;
    }
    .layer{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 150px;
        background: rgba(0, 0, 0, .6);
    }
    .content{
        position: absolute;
        left: 150px;
        top: 0;
        bottom: 0;
        width: 600px;
        padding: 40px 30px 130px;
        background: #fff;
        overflow-y: scroll;
    }
    .sidebar__item{
        padding: 30px 0;
    }
    .category__list{
        padding: 30px 0 0;
    }
    .category__item{
        width: 170px;
        height: 65px;
        margin: 15px 0 0 15px; 
        border-radius: 6px;
        background: #f5f5f5;
    }
    .category__item:nth-child(3n+1){
        margin-left: 0;
    }
    .category__item.active{
        background: #FFEEED;
        border: 2px solid #F93A42;
    }
    .footer{
        position: absolute;
        bottom: 0;
        left: 150px;
        width: 600px;
        height: 130px;
        padding: 0 30px;
        background: #fff;
        box-shadow: 2px 0 6px 2px #e6e6e6;
    }
    .footer button{
        width: 180px;
        height: 70px;
        line-height: 70px;
    }
    .reset{
        border-radius: 35px 0 0 35px;
        background: #FFAE27;
        font-size: 30px;
        color: #fff;
    }
    .sure{
        border-radius: 0 35px 35px 0;
        background: #FF3C44;
        font-size: 30px;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/pages/mall/List.vue